export const ComponentData: any = {
  AlertData: {
    /** 공통 */
    common: {
      confirmButtonText: "확인",
      cancelButtonText: "취소",
    },

    /** 버튼 2개 타입 얼럿 */
    delete: {
      // 일반 삭제
      icon: "warning",
      title: "모든 정보가 삭제 됩니다.",
      text: "삭제 하시겠습니까?",
    },
    deleteC: {
      // 완전 삭제
      icon: "warning",
      title: "데이터가 완전 삭제 됩니다.",
      text: "삭제 하시겠습니까?",
    },
    restore: {
      // 복원
      icon: "check",
      title: "",
      text: "데이터를 복원 하시겠습니까?",
    },
    bookmark: {
      // 즐겨찾기
      icon: "check",
      title: "",
      text: "즐겨찾기를 추가 하시겠습니까?",
    },
    bookmarkC: {
      // 즐겨찾기 해제
      icon: "warning",
      title: "",
      text: "즐겨찾기를 해제 하시겠습니까?",
    },

    /** 버튼 1개 타입 얼럿 */
    delete_success: {
      icon: "check",
      title: "",
      text: "삭제가 완료 되었습니다.",
    },
    unable: {
      // 수정/삭제 불가능
      icon: "warning",
      title: "",
      text: "사용자가 입력한 데이터로 수정/삭제가 불가능합니다.",
    },
    update: {
      // 수정
      icon: "check",
      title: "",
      text: "수정을 완료했습니다.",
    },
    createDateCheck: {
      // 등록일시 입력
      icon: "warning",
      title: "",
      text: "엑셀 내보내기는 등록일시 범위를 지정해야 사용할 수 있습니다.",
    },
    workFieldCheck: {
      icon: "warning",
      title: "",
      text: "업무 형태 변경 시 해당 업무형태의 조직원의 역할을 직접 변경해주셔야 합니다.",
    },
    noDelete: {
      icon: "warning",
      title: "",
      text: "삭제할 목록을 선택해주세요.",
    },
    counselDesignCheck: {
      icon: "warning",
      title: "",
      text: "설계 저장 시 해당 설계의 고객/담당자 정보가 변경됩니다.",
    },
    nullDesignTemplateId: {
      icon: "warning",
      title: "",
      text: "설계 정보를 준비 중입니다.",
    },
    counselFacilityType: {
      icon: "warning",
      title: "시설 상세 정보가 초기화 됩니다.",
      text: "계속 하시겠습니까?",
    },
  },

  /** dx-template */
  DxTemplate: {
    TwoLineDateData: {
      AM: "오전",
      PM: "오후",
    },
  },
} as const;
